export const UserConfig = ($stateProvider) => {
  'ngInject';
  $stateProvider.state('app.userListing', {
    url: '^/users',
    template: '<users-listing></users-listing>'
  });
  $stateProvider.state('app.userView', {
    url: '^/user-details-view/:id',
    template: '<user-view></user-view>'
  });
};


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/users/components/user.config.js
 **/